import styled from 'styled-components'

export const FeedBackIconContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	text-align: center;
	width: 90px;
	font-size: 11px;
`

export const ImageContainer = styled.img`
	margin-bottom: 8px; /* Отступ между изображением и текстом */
`

export const FeedBackDescription = styled.div`
	font-size: 12px;
`
